import { c as _c } from "react/compiler-runtime";
import React from 'react';
export function StrokeText(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      textShadow: "\n    -0.5px -0.5px 0 var(--color-ink),\n     0.5px -0.5px 0 var(--color-ink),\n    -0.5px  0.5px 0 var(--color-ink),\n     0.5px  0.5px 0 var(--color-ink)\n  "
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <span className="text-white" style={t1}>{children}</span>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}